import { render, staticRenderFns } from "./FormLand.vue?vue&type=template&id=163043b0&lang=html&"
import script from "./FormLand.vue?vue&type=script&lang=js&"
export * from "./FormLand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormLand.vue"
export default component.exports